function createRules(app) {
  return {
    businessNumber: [
      {
        max: 14,
        trigger: "change",
        message: app.$t("message.common.validation.max", {
          field: "登録番号",
          length: 14,
        }),
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: ['change', 'blur'],
        message: app.$t('message.common.validation.type', {
          field: "登録番号",
          type: '半角英数字'
        })
      }
    ],
    specificTransactionUrl: [
      {
        max: 256,
        trigger: "change",
        message: app.$t("message.common.validation.max", {
          field: "特定商取引法",
          length: 256,
        }),
      },
      {
        pattern: /^(https?|ftp|file):\/\/[^\s/$.?#].[^\s]*$/i,
        trigger: ['change', 'blur'],
        message: app.$t('message.common.validation.type', { field: '特定商取引法', type: 'URL' })
      },
    ],
    purchaseLinkUrl: [
      {
        max: 100,
        trigger: "change",
        message: app.$t("message.common.validation.max", {
          field: app.$t('label.destinationSetting.LinkedConnection.PurchaseRequest'),
          length: 100,
        }),
      },
      // {
      //   pattern: '^[^\x00-\xff]+$',
      //   trigger: 'change',
      //   message: app.$t('message.common.validation.type', {
      //     field: app.$t('label.destinationSetting.LinkedConnection.PurchaseRequest'),
      //     type: '全角'
      //   })
      // },
    ],
    customerLoginLinkUrl: [
      {
        max: 100,
        trigger: "change",
        message: app.$t("message.common.validation.max", {
          field: app.$t('label.destinationSetting.LinkedConnection.CustomerRequest'),
          length: 100,
        }),
      },
      // {
      //   pattern: "^[^\x00-\xff]+$",
      //   trigger: "change",
      //   message: app.$t("message.common.validation.type", {
      //     field: app.$t('label.destinationSetting.LinkedConnection.CustomerRequest'),
      //     type: "全角",
      //   }),
      // }
    ],
    regularApplyLinkUrl: [
      {
        max: 100,
        trigger: "change",
        message: app.$t("message.common.validation.max", {
          field: app.$t('label.destinationSetting.LinkedConnection.RegularApplicationContact'),
          length: 100,
        }),
      },
      // {
      //   pattern: "^[^\x00-\xff]+$",
      //   trigger: "change",
      //   message: app.$t("message.common.validation.type", {
      //     field: app.$t('label.destinationSetting.LinkedConnection.RegularApplicationContact'),
      //     type: "全角",
      //   }),
      // }
    ],
    linkOrgAddress: [
      {
        max: 100,
        trigger: "change",
        message: app.$t("message.common.validation.max", {
          field: app.$t('label.destinationSetting.LinkedConnection.SourceIP'),
          length: 100,
        }),
      },
      {
        pattern: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.destinationSetting.LinkedConnection.SourceIP'),
          type: '半角数字'
        })
      },
    ],
    linkHashKey: [
      {
        max: 100,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.destinationSetting.LinkedConnection.HashKey'),
          length: 100
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.destinationSetting.LinkedConnection.HashKey'),
          type: '半角英数字'
        })
      }
    ],
    apiLinkUrl: [
      {
        max: 100,
        trigger: "change",
        message: app.$t("message.common.validation.max", {
          field: app.$t('label.destinationSetting.APIConnectionInfo.APIEndpointVariety'),
          length: 100,
        }),
      },
      // {
      //   pattern: "^[^\x00-\xff]+$",
      //   trigger: "change",
      //   message: app.$t("message.common.validation.type", {
      //     field: app.$t('label.destinationSetting.APIConnectionInfo.APIEndpointVariety'),
      //     type: "全角",
      //   }),
      // }
    ],
    tokenServiceLinkUrl: [
      {
        max: 100,
        trigger: "change",
        message: app.$t("message.common.validation.max", {
          field: app.$t('label.destinationSetting.APIConnectionInfo.TokenServiceEndpoint'),
          length: 100,
        }),
      },
      // {
      //   pattern: "^[^\x00-\xff]+$",
      //   trigger: "change",
      //   message: app.$t("message.common.validation.type", {
      //     field: app.$t('label.destinationSetting.APIConnectionInfo.TokenServiceEndpoint'),
      //     type: "全角",
      //   }),
      // }
    ],
    emvSecurityLinkUrl: [
      {
        max: 100,
        trigger: "change",
        message: app.$t("message.common.validation.max", {
          field: app.$t('label.destinationSetting.APIConnectionInfo.SecureCardUserTokenEndpoint'),
          length: 100,
        }),
      },
      // {
      //   pattern: "^[^\x00-\xff]+$",
      //   trigger: "change",
      //   message: app.$t("message.common.validation.type", {
      //     field: app.$t('label.destinationSetting.APIConnectionInfo.SecureCardUserTokenEndpoint'),
      //     type: "全角",
      //   }),
      // }
    ],
    aplHashKey: [
      {
        max: 100,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.HashKey'),
          length: 100
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.HashKey'),
          type: '半角英数字'
        })
      }
    ],
    EncryptKey: [
      {
        max: 100,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.EncryptionKey'),
          length: 100
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.EncryptionKey'),
          type: '半角英数字'
        })
      }
    ],
    InitKey: [
      {
        max: 100,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.InitializationKey'),
          length: 100
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.InitializationKey'),
          type: '半角英数字'
        })
      }
    ],
    Padding: [
      {
        max: 100,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.paddingSetting'),
          length: 100
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.paddingSetting'),
          type: '半角英数字'
        })
      }
    ],
    basicAuthId: [
      {
        max: 100,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.AuthenticationID'),
          length: 100
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.AuthenticationID'),
          type: '半角英数字'
        })
      }
    ],
    basicAuthPassword: [
      {
        max: 100,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.AuthenticationPassword'),
          length: 100
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.AuthenticationPassword'),
          type: '半角英数字'
        })
      }
    ],
    apiOrgAddress: [
      {
        max: 100,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.SourceIPAddress'),
          length: 100
        })
      },
      {
        pattern: /^[0-9.]+$/,
        // pattern: /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.destinationSetting.APIConnectionInfo.SourceIPAddress'),
          type: '半角数字'
        })
      }
    ],
  }
}
export default {
  createRules: createRules
}
